/** @namespace routes */
import { register } from 'tmr/tmr/ngModuleRegistry'

import * as report from './report'
import * as asns from './asns/asns'
import * as asnView from './asns/asn.view'
import * as checklistsByUpc from './checklists/checklistsByUpc/checklistsByUpc'
import * as checklistsByItem from './checklists/checklistsByItem/checklistsByItem'
import * as checklistsByUpcForm from './checklists/checklistsByUpc/form'
import * as checklistsByItemForm from './checklists/checklistsByItem/form'
import * as conveyorPackageEvents from './conveyorPackageEvents/conveyorPackageEvents'
import * as conveyorPackageEventView from './conveyorPackageEvents/conveyorPackageEvent.view'
import * as eventLogs from './eventLogs/eventLogs'
import * as eventLogView from './eventLogs/eventLog.view'
import * as inventories from './inventories/inventories'
import * as inventoryView from './inventories/inventory.view'
import * as items from './items/items'
import * as itemView from './items/item.view'
import * as movementInboundView from './movements/movementInbound.view'
import * as movementInventoryConfirmationView from './movements/movementInventoryConfirmation.view'
import * as movementOutboundView from './movements/movementOutbound.view'
import * as movementReturnView from './movements/movementReturn.view'
import * as movements from './movements/movements'
import * as movementSaleView from './movements/movementSale.view'
import * as movementsEncoding from './movements/encoding/movementsEncoding'
import * as movementEncodingView from './movements/encoding/movementEncoding.view'
import * as movementsInbound from './movements/movementsInbound'
import * as movementsInventoryConfirmation from './movements/movementsInventoryConfirmation'
import * as movementsOutbound from './movements/movementsOutbound'
import * as movementsReturn from './movements/movementsReturn'
import * as movementsSale from './movements/movementsSale'
import * as movementsShippingInbound from './movements/movementsShippingInbound'
import * as movementShippingInboundView from './movements/movementShippingInbound.view'
import * as movementsShippingOutbound from './movements/movementsShippingOutbound'
import * as movementShippingOutboundView from './movements/movementShippingOutbound.view'
import * as movementsTransferToZone from './movements/movementsTransferToZone'
import * as movementTransferToZoneView from './movements/movementTransferToZone.view'
import * as movementView from './movements/movement.view'
import * as parcels from './parcels/parcels'
import * as parcelView from './parcels/parcel.view'
import * as productionLots from './productionLots/productionLots'
import * as productionLotsForm from './productionLots/form'
import * as productionLotsView from './productionLots/productionLots.view'
import * as productionOrderRows from './productionOrders/productionOrderRows'
import * as productionOrders from './productionOrders/productionOrders'
import * as productionOrderView from './productionOrders/productionOrder.view'
import * as products from './products/products'
import * as productsForm from './products/form'
import * as productView from './products/product.view'
import * as reportSession from './sessions/sessions'
import * as reportSessionView from './sessions/session.view'
import * as reportSessionMovement from './sessionMovements/sessionMovements'
import * as reportSessionMovementView from './sessionMovements/sessionMovement.view'
import * as shippingParcels from './shippingParcels/shippingParcels'
import * as shippingParcelView from './shippingParcels/shippingParcel.view'
import * as shippingParcelOperationDetails from './shippingParcels/shippingParcel.operationDetails'
import * as shippingNotices from './shippingNotices/shippingNotices'
import * as shippingNoticeView from './shippingNotices/shippingNotice.view'
import * as stock from './stock/stock'
import * as stockView from './stock/stock.view'
import * as transfers from './transfers/transfers'
import * as cycleCounts from './CycleCounts/cycleCounts'
import * as cycleCountView from './CycleCounts/cycleCounts.view'

export default register(
  'tmr.core.routes.report',
  report,
  asns,
  asnView,
  checklistsByUpc,
  checklistsByItem,
  checklistsByUpcForm,
  checklistsByItemForm,
  conveyorPackageEvents,
  conveyorPackageEventView,
  eventLogs,
  eventLogView,
  inventories,
  inventoryView,
  items,
  itemView,
  movements,
  movementsEncoding,
  movementEncodingView,
  movementsInbound,
  movementsInventoryConfirmation,
  movementsOutbound,
  movementsReturn,
  movementsSale,
  movementsShippingInbound,
  movementShippingInboundView,
  movementsShippingOutbound,
  movementShippingOutboundView,
  movementsTransferToZone,
  movementView,
  movementInboundView,
  movementInventoryConfirmationView,
  movementOutboundView,
  movementReturnView,
  movementSaleView,
  movementTransferToZoneView,
  parcels,
  parcelView,
  productionLots,
  productionLotsForm,
  productionLotsView,
  productionOrders,
  productionOrderRows,
  productionOrderView,
  products,
  productsForm,
  productView,
  reportSession,
  reportSessionView,
  reportSessionMovement,
  reportSessionMovementView,
  stock,
  stockView,
  shippingParcels,
  shippingParcelView,
  shippingNotices,
  shippingNoticeView,
  shippingParcelOperationDetails,
  transfers,
  cycleCounts,
  cycleCountView
)
